import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const MailIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 26 24"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M1 4H25M1 4V20H25V4M1 4L12 11.5C12.6 11.9 13.4 11.9 14 11.5L25 4" stroke={color} strokeWidth="2" />
  </Svg>
);

MailIcon.displayName = 'MailIcon';
